import {
    CREATE_WORKSPACE,
    DELETE_WORKSPACE,
    FETCH_ACTIVE_RUNS_SUCCESS,
    FETCH_WORKSPACES,
    FETCH_WORKSPACES_FAIL,
    FETCH_WORKSPACES_SUCCESS,
    REFRESH_WORKSPACE,
    RESET_WORKSPACE,
    WORKSPACE_ACTION_FAIL,
    WORKSPACE_ACTION_SUCCESS
} from './actionTypes';

export const fetchWorkspaces = () => ({
    type: FETCH_WORKSPACES
});

export const fetchWorkspacesSuccess = response => ({
    type: FETCH_WORKSPACES_SUCCESS,
    payload: response
});

export const fetchWorkspacesFail = error => ({
    type: FETCH_WORKSPACES_FAIL,
    payload: error
});

/* activeRuns: {sandbox code: how many of its runs are queued or running} (see countActiveRunsByWorkspace) */
export const fetchActiveRunsSuccess = activeRuns => ({
    type: FETCH_ACTIVE_RUNS_SUCCESS,
    payload: activeRuns
});

/* sourceCode: the production jurisdiction to clone. The server gives the new workspace its code. */
export const createWorkspace = ({ sourceCode }) => ({
    type: CREATE_WORKSPACE,
    payload: { sourceCode }
});

export const refreshWorkspace = ({ code }) => ({
    type: REFRESH_WORKSPACE,
    payload: { code }
});

export const resetWorkspace = ({ code }) => ({
    type: RESET_WORKSPACE,
    payload: { code }
});

export const deleteWorkspace = ({ code }) => ({
    type: DELETE_WORKSPACE,
    payload: { code }
});

/* key: what the call was made on, the code of the workspace or the source code for a workspace that is being created */
export const workspaceActionSuccess = ({ key }) => ({
    type: WORKSPACE_ACTION_SUCCESS,
    payload: { key }
});

export const workspaceActionFail = ({ key, error }) => ({
    type: WORKSPACE_ACTION_FAIL,
    payload: { key, error }
});
